const searchRes = {
    items: [
        {
            title: '4kWh Starter Kit',
            name: 'EcoFlow DELTA Pro 3 + PowerStream Microinverter 800W',
            power: '4kWh/3400W Solar Input/ 4800W Output',
            desc: '',
            coupon: '20%',
            couponText: '20% OFF',
            couponTips: '20% OFF',
            productId: '9494085927255',
            variantId: '48927477334359',
            moreLink: 'https://eu.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=48927477334359',
            img: 'https://websiteoss.ecoflow.com/upload/image/1729494395085/DP3%2BWN-EU.png',
            subs: [
                {
                    name: 'EcoFlow DELTA Pro 3 Smart Extra Battery',
                    desc: '4096Wh Capacity / Expandable up to 12kWh',
                    productId: '9488735895895',
                    variantId: '48911149236567',
                    discountPrice: 2499,
                    originalPrice: 2499,
                    inventoryQuantity: 50,
                    parentVarientId: '48927477334359',
                    img: 'https://cdn.shopify.com/s/files/1/0431/3789/2516/files/upsell-brand-site-ecoflow-delta-pro-3-smart-extra-battery-58715011449175.png?v=1724362824',
                },
                {
                    name: 'EcoFlow 400W Rigid Solar Panel (2 pieces)',
                    productId: '9488738320727',
                    variantId: '48911154610519',
                    discountPrice: 256,
                    originalPrice: 399,
                    inventoryQuantity: 50,
                    parentVarientId: '48927477334359',
                    img: 'https://cdn.shopify.com/s/files/1/0431/3789/2516/products/ecoflow-400w-rigid-solar-panel-42663959003300.png?v=1679653532',
                },
                {
                    name: 'EcoFlow Smart Plug',
                    productId: '8432538026327',
                    variantId: '46928801268055',
                    discountPrice: 36,
                    originalPrice: 36,
                    inventoryQuantity: 28348,
                    parentVarientId: '48927477334359',
                    img: 'https://cdn.shopify.com/s/files/1/0431/3789/2516/files/ecoflow-smart-plug-51054392508759.png?v=1685332345',
                },
            ],
            discountPrice: 3518,
            originalPrice: 3518,
            inventoryQuantity: -2997,
        },
        {
            title: '8kWh Extended Ease Kit',
            img: 'https://websiteoss.ecoflow.com/upload/image/1724747843980/bl_ps%2BDP3%2BEB_EU.png',
            name: 'EcoFlow DELTA Pro 3 + Extra Battery + PowerStream Microinverter 800W',
            power: '8kWh/3400W Solar Input/ 4800W Output',
            desc: '',
            productId: '9494085927255',
            variantId: '48927477465431',
            moreLink: 'https://eu.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=48927477465431',
            subs: [
                {
                    name: 'EcoFlow 400W Rigid Solar Panel (2 pieces)',
                    productId: '9488738320727',
                    variantId: '48911154610519',
                    discountPrice: 256,
                    originalPrice: 399,
                    inventoryQuantity: 50,
                    parentVarientId: '48927477465431',
                    img: 'https://cdn.shopify.com/s/files/1/0431/3789/2516/products/ecoflow-400w-rigid-solar-panel-42663959003300.png?v=1679653532',
                },
                {
                    name: 'EcoFlow Smart Plug',
                    productId: '8432538026327',
                    variantId: '46928801268055',
                    discountPrice: 36,
                    originalPrice: 36,
                    inventoryQuantity: 28348,
                    parentVarientId: '48927477465431',
                    img: 'https://cdn.shopify.com/s/files/1/0431/3789/2516/files/ecoflow-smart-plug-51054392508759.png?v=1685332345',
                },
            ],
            discountPrice: 5918,
            originalPrice: 6017,
            inventoryQuantity: -2997,
        },
        {
            title: '4kWh Home Battery',
            name: 'EcoFlow DELTA Pro 3',
            power: '4kWh/2600W Solar Input/ 4000W Output',
            desc: '',
            productId: '9488706797911',
            variantId: '48911033270615',
            moreLink: 'https://eu.ecoflow.com/products/delta-pro-3-portable-power-station?variant=48911033270615',
            img: 'https://websiteoss.ecoflow.com/upload/image/1729494351270/DP3-EU.png',
            subs: [
                {
                    name: 'EcoFlow Delta Pro 3 Smart Extra Battery',
                    desc: '4096Wh Capacity / Expandable up to 12kWh',
                    productId: '9488735895895',
                    variantId: '48911149236567',
                    discountPrice: 2499,
                    originalPrice: 2499,
                    inventoryQuantity: 50,
                    parentVarientId: '48911033270615',
                    img: 'https://cdn.shopify.com/s/files/1/0431/3789/2516/files/upsell-brand-site-ecoflow-delta-pro-3-smart-extra-battery-58715011449175.png?v=1724362824',
                },
                {
                    name: 'EcoFlow 400W Portable Solar Panel (1 piece)',
                    productId: '9488750870871',
                    variantId: '48911178858839',
                    discountPrice: 649,
                    originalPrice: 649,
                    inventoryQuantity: 50,
                    parentVarientId: '48911033270615',
                    img: 'https://cdn.shopify.com/s/files/1/0431/3789/2516/products/ecoflow-400w-portable-solar-panel-42463118393508.png?v=1675781009',
                },
            ],
            discountPrice: 2699,
            originalPrice: 3299,
            inventoryQuantity: 392,
        },
    ],
};

const bundlesRes = {
    code: '0',
    message: 'Success',
    data: {
        items: [
            {
                itemId: '1927247610915921922',
                itemType: 'shopifyBundle', // shopifyProduct
                retrieveId: '',
                score: 1,
                variants: [
                    {
                        productId: '6862944862281',
                        variantId: '40338014961737',
                        quantity: 1,
                        price: '699',
                        compareAtPrice: '1248',
                        img: 'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864264777.png?v=1722634998',
                        variantImg:
                            'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864297545.png?v=1722635004',
                        productTitle: 'EcoFlow RIVER 2 Pro Solar Generator (PV220W)',
                        skuTitle: 'RIVER 2 Pro + 220W Portable Solar Panel x 1',
                        variantDescription: '',
                        handle: '400w-rigid-solar-panel',
                        specific: '',
                    },
                    {
                        productId: '6770926125129',
                        variantId: '39993284034633',
                        quantity: 1,
                        price: '1996',
                        compareAtPrice: '2596',
                        img: 'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-2-1183168288.png?v=1754368129',
                        variantImg:
                            'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-4-1183200533.png?v=1754389967',
                        productTitle: 'EcoFlow NextGen 220W Bifacial Portable Solar Panel Bundle',
                        skuTitle: '220W Portable Solar Panel x 4',
                        variantDescription: '',
                        handle: '400w-rigid-solar-panel',
                        specific: '',
                    },
                    {
                        productId: '6770926125121',
                        variantId: '39993284034636',
                        quantity: 1,
                        price: '1996',
                        compareAtPrice: '2596',
                        img: 'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-2-1183168288.png?v=1754368129',
                        variantImg:
                            'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-4-1183200533.png?v=1754389967',
                        productTitle: 'EcoFlow NextGen 220W Bifacial Portable Solar Panel Bundle',
                        skuTitle: '220W Portable Solar Panel x 4',
                        variantDescription: '',
                        handle: '400w-rigid-solar-panel',
                        specific: '',
                    },
                ],
            },
            {
                itemId: '1927247610915921921',
                itemType: 'shopifyBundle', // shopifyProduct
                retrieveId: '',
                score: 1,
                variants: [
                    {
                        productId: '6862944862281',
                        variantId: '40338014961737',
                        quantity: 1,
                        price: '699',
                        compareAtPrice: '1248',
                        img: 'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864264777.png?v=1722634998',
                        variantImg:
                            'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864297545.png?v=1722635004',
                        productTitle: 'EcoFlow RIVER 2 Pro Solar Generator (PV220W)',
                        skuTitle: 'RIVER 2 Pro + 220W Portable Solar Panel x 1',
                        variantDescription: '',
                        handle: '400w-rigid-solar-panel',
                        specific: '',
                    },
                    {
                        productId: '6770926125129',
                        variantId: '399932840346337',
                        quantity: 1,
                        price: '1996',
                        compareAtPrice: '2596',
                        img: 'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-2-1183168288.png?v=1754368129',
                        variantImg:
                            'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-4-1183200533.png?v=1754389967',
                        productTitle: 'EcoFlow NextGen 220W Bifacial Portable Solar Panel Bundle',
                        skuTitle: '220W Portable Solar Panel x 4',
                        variantDescription: '',
                        handle: '400w-rigid-solar-panel',
                        specific: '',
                    },
                    {
                        productId: '6770926125121',
                        variantId: '399932840346338',
                        quantity: 1,
                        price: '1996',
                        compareAtPrice: '2596',
                        img: 'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-2-1183168288.png?v=1754368129',
                        variantImg:
                            'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-4-1183200533.png?v=1754389967',
                        productTitle: 'EcoFlow NextGen 220W Bifacial Portable Solar Panel Bundle',
                        skuTitle: '220W Portable Solar Panel x 4',
                        variantDescription: '',
                        handle: '400w-rigid-solar-panel',
                        specific: '',
                    },
                ],
            },
            {
                itemId: '1927247610915921923',
                itemType: 'shopifyBundle', // shopifyProduct
                retrieveId: '',
                score: 1,
                variants: [
                    {
                        productId: '6862944862281',
                        variantId: '40338014961737',
                        quantity: 1,
                        price: '699',
                        compareAtPrice: '1248',
                        img: 'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864264777.png?v=1722634998',
                        variantImg:
                            'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864297545.png?v=1722635004',
                        productTitle: 'EcoFlow RIVER 2 Pro Solar Generator (PV220W)',
                        skuTitle: 'RIVER 2 Pro + 220W Portable Solar Panel x 1',
                        variantDescription: '',
                        handle: '400w-rigid-solar-panel',
                        specific: '',
                    },
                    {
                        productId: '6770926125129',
                        variantId: '399932840346339',
                        quantity: 1,
                        price: '1996',
                        compareAtPrice: '2596',
                        img: 'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-2-1183168288.png?v=1754368129',
                        variantImg:
                            'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-4-1183200533.png?v=1754389967',
                        productTitle: 'EcoFlow NextGen 220W Bifacial Portable Solar Panel Bundle',
                        skuTitle: '220W Portable Solar Panel x 4',
                        variantDescription: '',
                        handle: '400w-rigid-solar-panel',
                        specific: '',
                    },
                ],
            },
        ],
    },
    eagleEyeTraceId: 'ea1a65682417549917480755361d0007',
    tid: '',
};

const productRes = {
    items: [
        {
            productId: '6770926125129',
            variantId: '3999328403463111',
            quantity: 1,
            price: '1996',
            compareAtPrice: '2596',
            img: 'https://websiteoss.ecoflow.com/website/upload/2022/3/7/Smart Home Panel Related_1646642664445.png',
            variantImg:
                'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-4-1183200533.png?v=1754389967',
            productTitle: 'Smart Home Panel',
            skuTitle: '220W Portable Solar Panel x 4',
            variantDescription: '',
            handle: '400w-rigid-solar-panel',
            specific: '',
        },

        {
            productId: '6770926125129',
            variantId: '3999328403463222',
            quantity: 1,
            price: '1996',
            compareAtPrice: '2596',
            img: 'https://websiteoss.ecoflow.com/website/upload/2022/3/7/DELTA PRO related_1646639685749.png',
            variantImg:
                'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-4-1183200533.png?v=1754389967',
            productTitle: 'EcoFlow DELTA Pro',
            skuTitle: '3.6—25kWh Capacity 3600W Output\nVerwendung während der Verwe',
            variantDescription: '',
            handle: '400w-rigid-solar-panel',
            specific: '',
        },

        {
            productId: '6770926125129',
            variantId: '39993284034633333',
            quantity: 1,
            price: '1996',
            compareAtPrice: '2596',
            img: 'https://websiteoss.ecoflow.com/website/upload/2022/7/6/110W-透明底（1200-1200）-新_1657104491271.png',
            variantImg:
                'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-4-1183200533.png?v=1754389967',
            productTitle: 'EcoFlow 110W Portable Solar Panel',
            skuTitle: '22.8% Conversion Rate | IP68',
            variantDescription: '',
            handle: '400w-rigid-solar-panel',
            specific: '',
        },
        {
            productId: '6770926125129',
            variantId: '39993284034634444',
            quantity: 1,
            price: '1996',
            compareAtPrice: '2596',
            img: 'https://websiteoss.ecoflow.com/website/upload/2022/7/6/110W-透明底（1200-1200）-新_1657104491271.png',
            variantImg:
                'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-220w-bifacial-portable-solar-panel-bundle-solar-panels-220w-portable-solar-panel-x-4-1183200533.png?v=1754389967',
            productTitle: 'EcoFlow 110W Portable Solar Panel',
            skuTitle: '22.8% Conversion Rate | IP68',
            variantDescription: '',
            handle: '400w-rigid-solar-panel',
            specific: '',
        },
    ],
};

const productRes2 = {
    code: '0',
    message: 'Success',
    data: {
        items: [
            {
                itemId: '1927247610915921922',
                itemType: 'shopifyProduct', // shopifyProduct
                retrieveId: '',
                score: 1,
                variants: [
                    {
                        productId: '6862944862281',
                        variantId: '403380149617371',
                        quantity: 1,
                        price: '699',
                        compareAtPrice: '1248',
                        img: 'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864264777.png?v=1722634998',
                        variantImg:
                            'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864297545.png?v=1722635004',
                        productTitle: 'EcoFlow RIVER 2 Pro Solar Generator (PV220W)',
                        skuTitle: 'RIVER 2 Pro + 220W Portable Solar Panel x 1',
                        variantDescription: '',
                        handle: '400w-rigid-solar-panel',
                        specific: '',
                    },
                    // {
                    //     productId: '68629448622812',
                    //     variantId: '4033801496173712',
                    //     quantity: 1,
                    //     price: '699',
                    //     compareAtPrice: '1248',
                    //     img: 'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864264777.png?v=1722634998',
                    //     variantImg:
                    //         'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864297545.png?v=1722635004',
                    //     productTitle: 'EcoFlow RIVER 2 Pro Solar Generator (PV220W)',
                    //     skuTitle: 'RIVER 2 Pro + 220W Portable Solar Panel x 1',
                    //     variantDescription: '',
                    //     handle: '400w-rigid-solar-panel',
                    //     specific: '',
                    // },
                ],
            },
            {
                itemId: '1927247610915921921',
                itemType: 'shopifyProduct', // shopifyProduct
                retrieveId: '',
                score: 1,
                variants: [
                    {
                        productId: '6862944862281',
                        variantId: '403380149617372',
                        quantity: 1,
                        price: '699',
                        compareAtPrice: '1248',
                        img: 'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864264777.png?v=1722634998',
                        variantImg:
                            'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864297545.png?v=1722635004',
                        productTitle: 'EcoFlow RIVER 2 Pro Solar Generator (PV220W)',
                        skuTitle: 'RIVER 2 Pro + 220W Portable Solar Panel x 1',
                        variantDescription: '',
                        handle: '400w-rigid-solar-panel',
                        specific: '',
                    },
                ],
            },
            {
                itemId: '1927247610915921923',
                itemType: 'shopifyProduct', // shopifyProduct
                retrieveId: '',
                score: 1,
                variants: [
                    {
                        productId: '6862944862281',
                        variantId: '403380149617373',
                        quantity: 1,
                        price: '699',
                        compareAtPrice: '1248',
                        img: 'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864264777.png?v=1722634998',
                        variantImg:
                            'https://cdn.shopify.com/s/files/1/1996/9707/files/ecoflow-us-ecoflow-river-2-pro-solar-generator-pv220w-bundle-32643864297545.png?v=1722635004',
                        productTitle: 'EcoFlow RIVER 2 Pro Solar Generator (PV220W)',
                        skuTitle: 'RIVER 2 Pro + 220W Portable Solar Panel x 1',
                        variantDescription: '',
                        handle: '400w-rigid-solar-panel',
                        specific: '',
                    },
                ],
            },
        ],
    },
    eagleEyeTraceId: 'ea1a65682417549917480755361d0007',
    tid: '',
};

export { searchRes, bundlesRes, productRes, productRes2 };
